import Dashboard from "../../../layout/Dashboard";
import { Content, Heading } from "../../../styles/OverviewStyle";
import { RFMain } from "../../../styles/RatesFeesStyle";
import { ListHead, ListRow } from "../../../styles/CrypoAssetStyle";
import { Icon } from '@iconify/react'
import { useState } from 'react'
import { TabNavigator } from "../components/Navigator";

type FeeType = 'Free' | 'Percentage' | 'Fixed'
type Row = { key: string; name: string; type: FeeType; amount: string }

const INITIAL_ROWS: Row[] = [
   { key: 'topup', name: 'Topup', type: 'Free', amount: 'N/A' },
   { key: 'withdrawal', name: 'Withdrawal', type: 'Percentage', amount: '0.5%' },
   { key: 'buy-crypto', name: 'Buy crypto', type: 'Percentage', amount: '1.2%' },
   { key: 'sell-crypto', name: 'Sell crypto', type: 'Percentage', amount: '0.5%' },
   { key: 'receive-crypto', name: 'Receive crypto', type: 'Free', amount: 'N/A' },
   { key: 'buy-giftcard', name: 'Buy giftcard', type: 'Percentage', amount: '0.35%' },
   { key: 'sell-giftcard', name: 'Sell giftcard', type: 'Fixed', amount: '₦50' },
   { key: 'receive-usd', name: 'Receive USD', type: 'Free', amount: 'N/A' },
   { key: 'convert-usd', name: 'Convert USD', type: 'Fixed', amount: '$0.75' },
]

export default function FeesPage() {
   const [rows, setRows] = useState<Row[]>(INITIAL_ROWS)
   const [editing, setEditing] = useState<{ key: string | null; type: FeeType; amount: string }>({ key: null, type: 'Free', amount: '' })

   const startEdit = (row: Row) => setEditing({ key: row.key, type: row.type, amount: row.amount })
   const cancelEdit = () => setEditing({ key: null, type: 'Free', amount: '' })
   const saveEdit = () => {
      if (!editing.key) return
      setRows(list => list.map(r => r.key !== editing.key ? r : {
         ...r,
         type: editing.type,
         amount: editing.amount
      }))
      cancelEdit()
   }

   return (
      <Dashboard title="Rates & Fees / Fees" icon="solar:tag-price-linear" active="rates_fees">
         <Content>
            <Heading>Rates & Fees</Heading>

            <TabNavigator active="fees" />

            <RFMain>
               <div>
                  <ListHead style={{ gridTemplateColumns: '1fr 200px 220px 120px 30px', columnGap: '30px' }}>
                     <div>Transaction</div>
                     <div>Fee type</div>
                     <div>Fee amount</div>
                     <div className="text-right pr-2">Role</div>
                  </ListHead>

                  {rows.map(row => {
                     const isEditing = editing.key === row.key
                     return (
                        <ListRow key={row.key} style={{ gridTemplateColumns: '1fr 200px 220px 120px 30px', columnGap: '30px' }}>
                           <div className="text-sm text-[#101018]">{row.name}</div>

                           <div className="w-[160px] ml-4">
                              {isEditing ? (
                                 <select
                                    value={editing.type}
                                    onChange={e => setEditing(s => ({ ...s, type: e.target.value as FeeType }))}
                                    className="w-full h-8 px-2 rounded-md border border-[#E7E7E9] bg-white text-sm text-[#101018] outline-none focus:border-[#AF7AD5]"
                                 >
                                    <option value="Free">Free</option>
                                    <option value="Percentage">Percentage</option>
                                    <option value="Fixed">Fixed</option>
                                 </select>
                              ) : (
                                 <span className="text-sm text-[#6D6D72]">{row.type}</span>
                              )}
                           </div>

                           <div className="w-[160px] ml-4">
                              {isEditing ? (
                                 <input
                                    value={editing.amount}
                                    onChange={e => setEditing(s => ({ ...s, amount: e.target.value }))}
                                    className="w-[120px] h-8 px-3 rounded-md border border-[#E7E7E9] bg-white text-sm text-[#101018] outline-none focus:border-[#AF7AD5]"
                                 />
                              ) : (
                                 <span className="text-sm text-[#6D6D72]">{row.amount}</span>
                              )}
                           </div>

                           <div className="w-[120px] ml-7 flex items-center justify-end gap-4">
                              {isEditing ? (
                                 <>
                                    <button aria-label="Cancel" onClick={cancelEdit}>
                                       <Icon icon="mdi:close" width={16} className="text-[#DD524D]" />
                                    </button>
                                    <button aria-label="Save" onClick={saveEdit}>
                                       <Icon icon="mdi:check" width={16} className="text-[#6D6D72]" />
                                    </button>
                                 </>
                              ) : (
                                 <button className="text-[#B3B3B6] text-xs hover:underline cursor-pointer inline-flex items-center gap-1" onClick={() => startEdit(row)} style={{
                                    padding: '6px 9px',
                                    borderRadius: '6px',
                                    border: '1px solid #EDEDEE',
                                    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.04)'
                                 }}>
                                    <Icon icon="solar:pen-2-linear" width={14} />
                                    Edit
                                 </button>
                              )}
                           </div>
                        </ListRow>
                     )
                  })}
               </div>
            </RFMain>
         </Content>
      </Dashboard>
   )
}
